import React from "react";
import { Check, Loader2 } from "lucide-react";
import { SITEDETAIL } from "@/constants/testIds";
import { isActive, itemKey, previewParamsFor, previewUrl } from "./catalog";

export const PREVIEW_W = 480;
const PREVIEW_H = 320;
const PREVIEW_SCALE = 0.375; // 1280 → 480

export function Flash({ flash }) {
  if (!flash) return null;
  return (
    <div data-testid="theme-picker-flash" className={`text-xs mono mt-4 ${flash.kind === "ok" ? "text-emerald-400" : "text-rose-400"}`}>
      {flash.kind === "ok" ? "✓ " : "✕ "}{flash.msg}
    </div>
  );
}

export function ScaledPreview({ src, title, w, h, scale, iframeKey }) {
  return (
    <div style={{ width: "100%", height: h, overflow: "hidden", background: "#fff" }}>
      <iframe src={src} title={title} loading="lazy" key={iframeKey}
        style={{ width: w / scale, height: h / scale, border: 0, transform: `scale(${scale})`, transformOrigin: "top left" }} />
    </div>
  );
}

/** One "shop-by-preview" tile: header row, optional palette swatch, live scaled SSR iframe. */
export function ThemeTile({ site, kind, item, bust, busy, onApply }) {
  const key = itemKey(item);
  const active = isActive(site, kind, item);
  return (
    <div data-testid={SITEDETAIL.themeTile(kind, key)}
      className={`border rounded-sm overflow-hidden bg-zinc-950 transition ${active ? "border-amber-500 ring-1 ring-amber-500/50" : "border-zinc-800 hover:border-zinc-600"}`}>
      <div className="flex items-center justify-between gap-2 px-3 py-2 border-b border-zinc-800 bg-zinc-900/40">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <div className="text-sm font-semibold truncate">{item.label}</div>
            {active && <span className="text-[10px] font-bold uppercase tracking-wider text-amber-300 bg-amber-500/15 border border-amber-500/40 px-1.5 py-0.5 rounded-sm">Active</span>}
          </div>
          <div className="text-[11px] text-zinc-500 truncate">{item.tagline}</div>
        </div>
        <button data-testid={SITEDETAIL.themeApply(kind, key)} onClick={() => onApply(kind, item)} disabled={!!busy || active}
          className={`shrink-0 inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm transition ${
            active ? "bg-amber-500/10 text-amber-400/70 cursor-default"
              : busy === `${kind}:${key}` ? "bg-amber-500/20 text-amber-200"
              : "bg-amber-500/20 hover:bg-amber-500/30 text-amber-200 border border-amber-500/40 disabled:opacity-40"}`}>
          {busy === `${kind}:${key}` ? <Loader2 className="w-3 h-3 animate-spin" /> : active ? <Check className="w-3 h-3" /> : null}
          {active ? "Applied" : "Apply"}
        </button>
      </div>
      {item.swatch && (
        <div className="flex h-7 border-b border-zinc-800">
          {["bg", "surface", "accent", "text"].map((k) => <div key={k} className="flex-1" style={{ background: item.swatch[k] }} title={k} />)}
        </div>
      )}
      <ScaledPreview src={previewUrl(site, previewParamsFor(kind, item), bust)} title={item.label} w={PREVIEW_W} h={PREVIEW_H} scale={PREVIEW_SCALE} />
    </div>
  );
}
